import type { CreateConnectorFn } from "wagmi"
import { createPrivyGlobalWalletConnector } from "./privyGlobalWallet"

function veeFriendsWalletConnector(): CreateConnectorFn {
  return createPrivyGlobalWalletConnector({
    displayName: "VeeFriends Wallet",
    iconUrl:
      "https://media.veefriends.com/image/upload/v1742394679/veefriends/v3/logos/logo-cat-white.png",
    privyAppId: "cm5158iom02kdwmj4wj527lc4",
    connectorId: "io.veefriends.privy",
  })
}

export { veeFriendsWalletConnector }
